<div fxLayout="column">
  <div fxLayout="row" fxLayoutGap="6px" fxFlexAlign="space-around stretch">
    <select fxFlex="auto" [ngModel]="service.month|async"
            (ngModelChange)="service.month.next($event)" [disabled]="disabled">
      <option [ngValue]="null" selected>Month</option>
      <option *ngFor="let item of service.monthList|async" [ngValue]="item[0]">{{item[1]}}</option>
    </select>
    <select *ngIf="showDay" fxFlex="auto" [ngModel]="service.day|async"
            (ngModelChange)="service.day.next($event)" [disabled]="disabled">
      <option [ngValue]="null" selected>Day</option>
      <option *ngFor="let item of service.dayList|async" [ngValue]="item">{{item}}</option>
    </select>
    <select fxFlex="auto" [ngModel]="service.year|async"
            (ngModelChange)="service.year.next($event)" [disabled]="disabled">
      <option [ngValue]="null" selected>Year</option>
      <option *ngFor="let item of service.yearList|async" [ngValue]="item">{{item}}</option>
    </select>

    <mat-datepicker #picker [disabled]="disabled" [touchUi]="touchUi" [startView]="startView"></mat-datepicker>
    <a *ngIf="showDatePicker" tabindex="0" fxFlex="auto" class="calendar-button" (click)="picker.open()">
      <i class="fa fa-calendar"></i>
    </a>
  </div>
  <input class="date-picker-input" style="width:100px" fxFlex="auto"
         [matDatepicker]="picker" [min]="service.min|async" [max]="service.max|async"
         [(ngModel)]="datePickerValue">
</div>
